import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import BackIcon from '@fortawesome/fontawesome-free-solid/faLongArrowAltLeft'

import Icon from '../../../common/icon'
import { TextInput, Button2 } from '../../../common'

import * as Constants from '../../../../helpers/Constants'
import * as Strings from './strings'
import * as configActions from '../../../../actions/Config'
import * as userActions from '../../../../actions/User'

class Prices extends Component {
  constructor(props) {
    super(props)
    this.state = {
      emailInput: ''
    }

    this.enterHandler = this.enterHandler.bind(this)
  }

  componentWillMount() {
    window.addEventListener('keypress', this.enterHandler)
  }

  componentWillUnmount() {
    window.removeEventListener('keypress', this.enterHandler)
  }

  enterHandler(e) {
    const { alert } = this.props
    if (e.charCode === 13 && alert.id === null) {
      this.reset()
    } else {
      this.props.hideAlert()
    }
  }

  reset() {
    const { config } = this.props
    const { emailInput } = this.state

    if (emailInput === '') {
    } else {
      const data = { email: emailInput }

      this.props.tryResetPassword(data, config.language, (h, i, t, b) =>
        this.props.showAlert(h, i, t, b)
      )
    }
  }

  render() {
    const { config, user } = this.props
    const { emailInput } = this.state

    return (
      <div className={'basicCentered'}>
        <div
          onClick={() => this.props.history.push('/')}
          className={'backSection'}
        >
          <FontAwesomeIcon className={'backIcon'} icon={BackIcon} />
          <p className={'backText'}>
            {Strings.default.BACK_TO_LOGIN[config.language]}
          </p>
        </div>
        <div className={'basicContainer'}>
          <h5>{Strings.default.RESET_PASSWORD[config.language]}</h5>
          <Input
            header={Strings.default.EMAIL[config.language]}
            value={emailInput}
            onChange={text => this.setState({ emailInput: text })}
          />
          <Button2
            header={Strings.default.SEND_RESET_MAIL[config.language]}
            onClick={() => this.reset()}
            loading={user.isResetingPassword}
          />
        </div>
      </div>
    )
  }
}

const Input = ({ header = '', value, onChange, type }) => {
  return (
    <TextInput
      width={'100%'}
      header={header}
      type={type}
      value={value}
      onChange={value => onChange(value)}
      underlineFocusStyle={{
        borderColor: Constants.WHITE_LABEL.colors.primary
      }}
      floatingLabelFocusStyle={{ color: Constants.WHITE_LABEL.colors.primary }}
    />
  )
}

function mapStateToProps({ config, user }) {
  return { config, user }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...configActions, ...userActions }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Prices)



// WEBPACK FOOTER //
// ./src/components/pages/preLogin/ForgotPassword/index.js